<template>
    <div class="wk-textarea wk-input-box">
        <span class="input-left-label">{{labelOver}}</span>
        <div class="posi-relative">
            <textarea-base v-model="inputVal" :placeholder="placeholderOver" :maxlength="maxlength" :initVal="value"/>
            <div class="posi-absolute right-box">
                <slot></slot>
            </div>
        </div>
    </div>
</template>
 
<script>
    export default {
        name: 'inputlsit',
        props: ['label','placeholder','maxlength','value'],
        mounted(){
            //label
            if(this.label){
                this.labelOver = this.label;
            }
            //提示
            if(this.placeholder){
                this.placeholderOver =  this.placeholderOver + this.placeholder;
            }else if(this.label){
                this.placeholderOver =  this.placeholderOver + this.label;
            }
        },
        watch:{
            inputVal(){
                this.$emit('input',this.inputVal)
            }
        },
        data(){
            return{
                inputVal:'',
                labelOver:'',
                placeholderOver:''
            }
        },
    }
</script>
<style lang="less" scoped>
    .wk-textarea{
        margin-top:.9rem;
        >div{
            >div.right-box{
                top:0;
                left:100%;
                >img{
                    margin:.5rem 0 0 .5rem;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/BaseCpts/wkTextarea.vue